module.exports = {"title":{"en":"Expired","de":"Verifikation abgelaufen","ro":"Cod expirat"},"alertText":{"en":"Your unique verification session has expired, please request a new one.","de":"Leider hat die Verifikation zu lange gedauert. Bitte starten sie erneut.","ro":"Codul tău unic de verificare a expirat, te rugăm să soliciți unul nou în aplicație"}}


//////////////////
// WEBPACK FOOTER
// ./src/localization/localization-expired.json
// module id = 113
// module chunks = 0